import { InjectionToken } from '@angular/core';
import { StatusColorConfig } from './status-color-config';

export const STATUS_COLOR_DEFAULT_CONFIG = new InjectionToken<
  StatusColorConfig
>('STATUS COLOR DEFAULT CONFIG', {
  providedIn: 'root',
  factory: STATUS_COLOR_DEFAULT_CONFIG_FACTORY
});

export function STATUS_COLOR_DEFAULT_CONFIG_FACTORY(): StatusColorConfig {
  return {
    black: {
      backgroundColor: '#000',
      foregroundColor: '#fff'
    },
    gold: {
      backgroundColor: '#cca744',
      foregroundColor: '#fff'
    },
    platinum: {
      backgroundColor: '#c0c0c0',
      foregroundColor: '#000'
    },
    error: {
      backgroundColor: '#b3243d',
      foregroundColor: '#fff'
    },
    warn: {
      backgroundColor: '#f9a562',
      foregroundColor: '#fff'
    },
    success: {
      backgroundColor: '#18b6a0',
      foregroundColor: '#fff'
    }
  };
}
